<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-subheader class="pl-0">{{ $t('views.fields.cycle.start_date') }}</v-subheader>
          <date-picker
            placeholder="Selecione a data"
            :not-after="startDateBeforeEndDate()"
            v-model="resource.start_date"
            :lang="lang"
            :editable="false"
            format="DD/MM/YYYY"
            :error-messages="validationErrors.start_date"
            clearable></date-picker>
        </v-flex>

        <v-flex xs12 md3>
          <v-subheader class="pl-0">{{ $t('views.fields.cycle.end_date') }}</v-subheader>
          <date-picker
            placeholder="Selecione a data"
            :not-before="resource.start_date"
            v-model="resource.end_date"
            :lang="lang"
            :editable="false"
            :disabled="(!resource.start_date || resource.start_date === '')"
            format="DD/MM/YYYY"
            :error-messages="validationErrors.end_date"
            clearable></date-picker>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field
            name="name"
            :label="$t('views.fields.cycle.name')"
            :error-messages="validationErrors.name"
            v-model="resource.name"></v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-select
            :items="clients"
            item-text="name"
            item-value="id"
            hint="Vincular um cliente a este ciclo"
            v-model="client"
            required
            return-object
            persistent-hint
            clearable
            :disabled="(clients.length === 0)"
            no-data-text="Nenhuma registro encontrado"
            :error-messages="validationErrors.client_id"
            label="Selecione um cliente"></v-select>
        </v-flex>

        <v-flex xs12 md2 v-if="resource.id">
          <v-select
            :items="activeOptions"
            v-model="resource.active"
            item-text="description"
            item-value="value"
            :error-messages="validationErrors.active"
            label="Status do Ciclo">
          </v-select>
        </v-flex>

        <v-flex xs12 md2>
          <v-text-field
            :mask="'###'"
            v-model="resource.qtd_hours"
            label="Quantidade Horas"
            required
            :error-messages="validationErrors.qtd_hours"></v-text-field>
        </v-flex>

        <v-flex xs12 md12>
          <v-textarea
            name="note"
            :label="$t('views.fields.cycle.note')"
            v-model="resource.note"></v-textarea>
        </v-flex>

      </v-layout>

      <v-alert
        :value="showAlert"
        type="error">
        Não existem clientes cadastrados no sistema.
      </v-alert>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :disabled="(clients.length === 0)" :loading="saveLoading">
          Salvar
        </v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import CrudMixin from '@/components/mixins/CrudMixin';
import CycleService from '@/features/cycle/CycleService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'cycle-form',
  mixins: [CrudMixin],
  components: { DatePicker },
  data() {
    return {
      activeOptions: [
        { description: 'ATIVO', value: 'sim' },
        { description: 'INATIVO', value: 'nao' },
      ],
      showAlert: false,
      lang: 'pt-br',
      clients: [],
      client: {},
      clientService: new ClientService(),
    };
  },
  created() {
    this.loadClient();
  },
  methods: {
    initCrud() {
      this.serviceType = CycleService;
      this.routerName = 'cycle';
      this.componentType = 'FORM';
    },
    beforeSave() {
      this.resource.client_id = this.client ? this.client.id : null;
    },
    afterLoadResource() {
      this.clients.push(this.resource.client);
      this.client = { id: this.resource.client.id, name: this.resource.client.name };
    },
    loadClient() {
      this.clientService.query().then((data) => {
        this.clients = data;
        if (this.clients.length === 0) this.showAlert = true;
      });
    },
    endDateBeforeStartDate() {
      let dateStart = new Date();
      if (this.resource.start_date && this.resource.start_date !== '') {
        dateStart = moment(this.resource.start_date).toDate();
      }
      return dateStart;
    },
    startDateBeforeEndDate() {
      let dateEnd = null;
      if (this.resource.end_date && this.resource.end_date !== '') {
        dateEnd = moment(this.resource.end_date).toDate();
      }
      return dateEnd;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/cycle/CycleForm.vue